(function () {
  'use strict';

  if (window.junipLiveStats) return;
  window.junipLiveStats = true;

  var API_URL = 'https://api.juniphq.com/en/v1/product_overviews';
  var MAX_PAGES = 20;
  var CACHE_TTL_MS = 30 * 60 * 1000;

  var selectors = {
    rating: '[data-junip-rating]',
    count: '[data-junip-count]',
    stars: '[data-junip-stars]'
  };

  var scriptEl = document.currentScript || document.querySelector('script[data-junip-store-key]');
  var lastAggregate = null;

  function formatCount(value) {
    return value.toLocaleString('en-US');
  }

  function fetchPage(storeKey, after) {
    var url = API_URL;
    if (after) url += '?after=' + encodeURIComponent(after);

    return fetch(url, {
      method: 'GET',
      mode: 'cors',
      credentials: 'omit',
      headers: {
        'content-type': 'application/json',
        'junip-store-key': storeKey
      }
    }).then(function (response) {
      if (!response.ok) throw new Error('Junip request failed: ' + response.status);
      return response.json();
    });
  }

  function fetchAllOverviews(storeKey) {
    var overviews = [];

    function loadPage(after, pageCount) {
      if (pageCount >= MAX_PAGES) return Promise.resolve(overviews);

      return fetchPage(storeKey, after).then(function (data) {
        overviews = overviews.concat(data.product_overviews || []);

        var nextAfter = data.meta && data.meta.page ? data.meta.page.after : null;
        if (!nextAfter) return overviews;

        return loadPage(nextAfter, pageCount + 1);
      });
    }

    return loadPage(null, 0);
  }

  function aggregateOverviews(overviews) {
    var reviewCount = 0;
    var weightedRatingSum = 0;

    overviews.forEach(function (product) {
      var ratingCount = product.rating_count || 0;
      reviewCount += ratingCount;
      weightedRatingSum += (product.rating_average || 0) * ratingCount;
    });

    if (reviewCount === 0) return null;

    return {
      ratingAverage: weightedRatingSum / reviewCount,
      reviewCount: reviewCount
    };
  }

  function renderAggregate(root, aggregate) {
    root.querySelectorAll(selectors.rating).forEach(function (el) {
      el.textContent = aggregate.ratingAverage.toFixed(1);
    });

    root.querySelectorAll(selectors.count).forEach(function (el) {
      el.textContent = formatCount(aggregate.reviewCount);
    });

    root.querySelectorAll(selectors.stars).forEach(function (el) {
      el.style.setProperty('--rating', aggregate.ratingAverage);
    });
  }

  function cacheKey(storeKey) {
    return 'junip-live-stats:' + storeKey;
  }

  function readCache(storeKey) {
    try {
      var raw = sessionStorage.getItem(cacheKey(storeKey));
      if (!raw) return null;

      var parsed = JSON.parse(raw);
      if (!parsed || typeof parsed.savedAt !== 'number') return null;
      if (Date.now() - parsed.savedAt > CACHE_TTL_MS) return null;

      return parsed.aggregate;
    } catch (e) {
      return null;
    }
  }

  function writeCache(storeKey, aggregate) {
    try {
      sessionStorage.setItem(cacheKey(storeKey), JSON.stringify({ savedAt: Date.now(), aggregate: aggregate }));
    } catch (e) {
      // sessionStorage unavailable (Safari private mode, third-party storage blocked) -- skip caching.
    }
  }

  function apply(aggregate) {
    lastAggregate = aggregate;
    renderAggregate(document, aggregate);

    if (typeof CustomEvent === 'function') {
      document.dispatchEvent(new CustomEvent('junip:stats', { detail: aggregate }));
    }
  }

  function hasHooks() {
    return !!(
      document.querySelector(selectors.rating) ||
      document.querySelector(selectors.count) ||
      document.querySelector(selectors.stars)
    );
  }

  function init(storeKey) {
    var cached = readCache(storeKey);
    if (cached) {
      apply(cached);
      return;
    }

    fetchAllOverviews(storeKey)
      .then(function (overviews) {
        var aggregate = aggregateOverviews(overviews);
        if (!aggregate) return;

        writeCache(storeKey, aggregate);
        apply(aggregate);
      })
      .catch(function () {
        // Live fetch failed -- leave the server-rendered fallback values in place.
      });
  }

  function bootstrap() {
    if (!scriptEl) return;

    var storeKey = scriptEl.getAttribute('data-junip-store-key');
    var live = scriptEl.getAttribute('data-junip-live');
    if (!storeKey || live !== 'true') return;
    if (!hasHooks()) return;

    document.addEventListener('shopify:section:load', function (event) {
      if (lastAggregate) renderAggregate(event.target, lastAggregate);
    });

    init(storeKey);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
